import {
  CalendarDaysIcon,
  ChatBubbleLeftRightIcon,
  ClockIcon,
  ExclamationCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
  LinkIcon,
} from '@heroicons/react/24/outline';
import type { tAlertPriority } from 'src/alerts/AlertCenter.types';
import type { tNotificationIcon } from 'src/notifications/AgendaNotifications.types';

/**
 * Severity is never carried by hue alone (WCAG 1.4.1): each tier gets a
 * distinct glyph as well as a distinct colour, so an alert still reads under
 * greyscale, colour-blindness, or a forced-colours theme.
 *
 * Shared by the navbar chip and the panel row on purpose — a tier that looked
 * like one thing in the bar and another in the panel would be two alerts as far
 * as the user is concerned.
 */
export const ALERT_TIER_ICON: Record<
  tAlertPriority,
  typeof ExclamationTriangleIcon
> = {
  p0: ExclamationTriangleIcon,
  p1: ExclamationCircleIcon,
  p2: InformationCircleIcon,
  p3: InformationCircleIcon,
};

/**
 * AGI-346 — the tray's glyphs, keyed by what the row IS. Deliberately NOT the
 * tier icons above: those encode severity, and a booked appointment has no
 * severity to encode. Reusing a warning triangle for "Damo booked Thursday"
 * would tell the user something is wrong when nothing is.
 */
export const NOTIFICATION_ICON: Record<
  tNotificationIcon,
  typeof CalendarDaysIcon
> = {
  appointment: CalendarDaysIcon,
  connection: LinkIcon,
  reminder: ClockIcon,
  handoff: ChatBubbleLeftRightIcon,
};
